import api from "../../../services/axiosConfig";

export const fetchProjects = async () => {
  try {
    const response = await api.get("/instances/skeye/skeyecube/list-projects", {
      data: {},
    });
    const projectsString = response.data.data.projects;
    const projectsRaw =
      typeof projectsString === "string" ? JSON.parse(projectsString) : [];
    const projects = projectsRaw.map((p) => ({
      name: p.name,
      owner: p.owner,
      num_cubes: Array.isArray(p.tables) ? p.tables.length : 0,
      created: p.create_time_utc
        ? new Date(p.create_time_utc).toLocaleString()
        : "",
    }));
    return projects;
  } catch (error) {
    console.error("Error fetching projects:", error);
    throw error;
  }
};

export const createProject = async (projectData) => {
  try {
    const response = await api.post(
      "/instances/skeye/skeyecube/create-project",
      projectData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error creating project:", error);
    throw error;
  }
};

export const deleteProject = async (projectName) => {
  try {
    const response = await api.delete(
      `/instances/skeye/skeyecube/delete-project/${encodeURIComponent(
        projectName,
      )}`,
      {
        data: {},
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting project:", error);
    throw error;
  }
};
